enum AppMediumType {
    FiApiServiceAccount = "FI_API_SERVICE_ACCOUNT",
    UxApiCustomerAccess = "UX_API_CUSTOMER_ACCESS",
    UxApiServiceAccount = "UX_API_SERVICE_ACCOUNT",
}
export default AppMediumType